<template>
  <div class="dropdown fullwidth" :class="{'is-active': open}" v-click-outside="() => open = false">
    <div class="dropdown-trigger fullwidth">
      <button class="button is-fullwidth is-justify-content-space-between" @click.prevent="open = !open">
        <span>{{ selected }}</span>
        <span class="icon is-small">
          <i class="fas fa-angle-down" aria-hidden="true"></i>
        </span>
      </button>
    </div>
    <div class="dropdown-menu fullwidth" id="dropdown-menu" role="menu">
      <div class="dropdown-content">
        <a
          v-for="(item, key) in items"
          :key="key"
          @click.prevent="select(item, key)"
          href="#"
          class="dropdown-item"
        >
          {{ optionTitle ? item[optionTitle] : item }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: [Number, String, Object],
    items: {
      type: Array,
      default: () => ([])
    },
    optionTitle: String,
    optionValue: String,
    valueObject: Boolean,
    closeSelected: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
    selected () {
      let selected = this.items.filter((el) => {
        let res = false
        if (this.valueObject && this.optionValue) {
          res = el[this.optionValue] === this.value[this.optionValue]
        } else if (this.optionValue) {
          res = el[this.optionValue] === this.value
        }
        return res
      })[0]
      if (!this.valueObject && !this.optionValue) selected = this.items[this.value]
      return selected && this.optionTitle ? selected[this.optionTitle] : selected || 'no selected'
    }
  },
  methods: {
    select (item, key) {
      this.$emit('input', this.valueObject ? item : this.optionValue ? item[this.optionValue] : key)
      if (this.closeSelected) this.open = false
    }
  }
}
</script>
